import axios from "axios";

axios.defaults.baseURL = `https://kupidai-prod.up.railway.app/shop-service/api`;

export const fetch = async (endpoint) => {
  const response = await axios.get(endpoint);
  return response;
};

